import { render, staticRenderFns } from "./ItemVariationNameMobile.vue?vue&type=template&id=4c5dff42&"
import script from "./ItemVariationNameMobile.vue?vue&type=script&lang=js&"
export * from "./ItemVariationNameMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports